import React from 'react';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Avatar, AvatarRadii } from 'components/Avatar';

import dashboardStyles from '../Dashboard.module.scss';
import { useListOwnAssociations } from 'legacy/groups/hooks';
import { getCountryName, getProvinceStateName } from './helpers';

const AssociationsList = ({ device }) => {
  const { t } = useTranslation('dashboard');
  const router = useRouter();
  const { data: associations, isLoading } = useListOwnAssociations();

  const navigateToAssociation = (associationId) => {
    router.push(`associations/${associationId}`);
  };

  if (!isLoading && associations?.length === 0) {
    return null;
  }

  return (
    <div className={classnames('bn-container', 'min-h-[115px]', device)}>
      <div className={dashboardStyles.cardHeader}>
        <span className={dashboardStyles.cardTitle}>
          {t('associations.title')}
        </span>
      </div>
      <div>
        {associations.map((association, index) => (
          <div
            key={`${association.id}-${association.name}`}
            className="flex items-center cursor-pointer py-4 px-3 hover:bg-primary-50 overflow-hidden gap-2"
            role="button"
            tabIndex={index}
            onClick={() => navigateToAssociation(association.id)}
          >
            <div>
              <Avatar src={association.logoImage} radius={AvatarRadii.Lg} />
            </div>
            <div className="flex-1 flex flex-col overflow-hidden">
              <p className="font-bold">{association.name}</p>
              <p className="text-ellipsis whitespace-nowrap overflow-hidden">
                {`${association.address.city}, ${getProvinceStateName(
                  association.country,
                  association.address.state
                )}, ${getCountryName(association.country)}`}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  self: state.user.user
});

export default connect(mapStateToProps)(AssociationsList);
